module.exports = __webpack_public_path__ + "de1e9c5de12d833cd589529efab9f19e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/appStore.svg
// module id = 1382
// module chunks = 16